import axios from 'axios';
import type { Usuario } from '@eleg360/types';

/** Espelha a entidade `core.audit`. */
export interface AuditLog {
  id: string;
  tenant_id: string;
  actor_id: string;
  acao: string;
  objeto: string;
  origem: string;
  payload_hash: string;
  isenta: boolean;
  ts: string;
}

/** Espelha a entidade `core.outbox`. */
export interface Outbox {
  id: string;
  tenant_id: string;
  event: string;
  payload: Record<string, any>;
  consumer: string;
  status: string;
  retries: number;
  last_error?: string;
  created_at: string;
  updated_at: string;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const authApi = {
  login: async (email: string, senha: string) => {
    const res = await axios.post<{ mfaRequired?: boolean; tempToken?: string; token?: string; user?: Usuario }>(
      `${API_URL}/auth/login`,
      { email, senha }
    );
    return res.data;
  },

  verifyMfa: async (tempToken: string, code: string) => {
    const res = await axios.post<{ token: string; user: Usuario }>(
      `${API_URL}/auth/mfa`,
      { tempToken, code }
    );
    return res.data;
  },

  getUsuarios: async (token: string) => {
    const res = await axios.get<Usuario[]>(`${API_URL}/auth/usuarios`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getAuditoria: async (token: string) => {
    const res = await axios.get<AuditLog[]>(`${API_URL}/auth/auditoria`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getOutbox: async (token: string) => {
    const res = await axios.get<Outbox[]>(`${API_URL}/auth/outbox`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  /**
   * Devolve para a fila os eventos que falharam. Sem `id`, reprocessa todos.
   * Eventos cancelados por regra de conformidade não são alcançados.
   */
  reprocessarOutbox: async (token: string, id?: string) => {
    const res = await axios.post<{ reenfileirados: number }>(
      `${API_URL}/auth/outbox/reprocessar`,
      id ? { id } : {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return res.data;
  },

  /** Pública: só diz se o link de definição de senha ainda serve. */
  validarTokenDefinirSenha: async (tokenLink: string) => {
    const res = await axios.get<{ valido: boolean; nome?: string }>(
      `${API_URL}/auth/definir-senha/${encodeURIComponent(tokenLink)}`,
    );
    return res.data;
  },

  /** Pública: grava a senha escolhida por quem tem o link. */
  definirSenha: async (tokenLink: string, novaSenha: string) => {
    const res = await axios.post<{ ok: true }>(`${API_URL}/auth/definir-senha`, {
      token: tokenLink,
      novaSenha,
    });
    return res.data;
  },
};
